<template>
  <div class="product-list">
    <div>
      <div>
        <p>关键人定位</p>
        <span>您可以获得以下权益:</span>
      </div>
      <ul>
        <li>
          <div>
            <ul>
              <li>套餐在支付后即时生效，有效期截止至购买日起第7日当天同一时间(以支付成功时间为准)；</li>
              <li>在套餐有效期内，用户每日可查询数据总量200条；</li>
              <li>查询后的数据可通过收藏保存至会员中心-我的关键人中；</li>
              <li>会员中心查询数据可随时查询使用，不做额外收费。</li>
            </ul>
            <span>
              <b>9.99</b> 元（7天）</span>
            <a-button @click="purchase(1)" :disabled="comboMsg.some(c=>c.id==1&&c.permission==0)">购买套餐</a-button>

          </div>
        </li>
      </ul>
    </div>
    <div>
      <div>
        <p>采购商查询</p>
        <span>您可以获得以下权益:</span>
      </div>
      <ul>
        <li>
          <div>
            <ul>
              <li>套餐在支付后即时生效，有效期截止至购买日起次年当天同一时间(以支付成功时间为准)；</li>
              <li>在套餐有效期内，用户每日可查询数据总量100条；</li>
              <li>查询后的数据可通过关注收藏至会员中心-我的采购商中；</li>
              <li>会员中心查询数据可随时查询使用，不做额外收费；</li>
              <li>可享受关键人定位套餐权益内服务，有效期为一年。</li>
            </ul>
            <span>
              <b>2999</b> 元（1年）</span>
            <a-button @click="purchase(2)" :disabled="comboMsg.some(c=>c.id==2&&c.permission==0)">购买套餐</a-button>
          </div>
        </li>
        <li>
          <div>
            <ul>
              <li>套餐在支付后即时生效，有效期截止至购买日起次月当天同一时间(以支付成功时间为准)；
              </li>
              <li>在套餐有效期内，用户每日可查询数据总量80条；
              </li>
              <li>查询后的数据可通过关注收藏至会员中心-我的采购商中；
              </li>
              <li>会员中心查询数据可随时查询使用，不做额外收费；
              </li>
              <li>可享受关键人定位套餐权益内服务，有效期一个月。
              </li>
            </ul>
            <span>
              <b>299</b> 元（1个月）</span>
            <a-button @click="purchase(3)" :disabled="comboMsg.some(c=>c.id==3&&c.permission==0)">购买套餐</a-button>

          </div>
        </li>
        <li>
          <div>
            <ul>
              <li>套餐在支付后即时生效，有效期截止至购买日起第7日当天同一时间(以支付成功时间为准)；</li>
              <li>在套餐有效期内，用户每日可查询数据总量60条；</li>
              <li>查询后的数据可通过关注收藏至会员中心-我的采购商中；</li>
              <li>会员中心账户中的查询数据可随时查询使用，不做额外收费。</li>
            </ul>
            <span>
              <b>99</b> 元（7天）</span>
            <a-button @click="purchase(4)" :disabled="comboMsg.some(c=>c.id==4&&c.permission==0)">购买套餐</a-button>

          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      comboMsg: []
    };
  },
  created() {
    this.$http
      .post("/comboMsg")
      .then(res => {
        if (!res.error) {
          this.comboMsg = res.data.comboMsg;
        } else {
          console.error(res.errorMsg);
        }
      })
      .catch(e => {
        console.error(e);
      });
  },
  methods: {
    purchase(productId) {
      this.$emit("purchase", productId);
    }
  }
};
</script>
<style lang="scss" scoped>
.product-list {
  text-align: center;
  margin-bottom: 100px;
  & > div {
    display: inline-block;
    border: 1px solid #e5e5e5;
    margin: auto 5px;
    & > div {
      background-color: #f5f5f5;
      height: 80px;
      p {
        font-size: 16px;
        font-weight: bold;
        padding: 15px 0 5px;
        margin: 0;
      }
      span {
        font-size: 13px;
      }
    }
    &:hover {
      border: 1px solid #0b97e0;
    }
    &:hover > div {
      background-color: #0b97e0;
      color: #fff;
    }
    & > ul {
      margin: 0;
      padding: 0;
      list-style: none;
      display: inline-block;
      & > li {
        display: inline-block;
        width: 260px;
        height: 435px;

        &:not(:first-child) {
          border-left: 1px solid #f1f1f1;
        }
        div {
          display: flex;
          flex-flow: column;
          height: 100%;
          span {
            margin: 10px;
            b {
              font-size: 18px;
              color: #fe932b;
            }
          }
          & > ul {
            flex: 1;
            text-align: left;
            list-style: decimal;
            padding: 0 20px 0 30px;
            li {
              margin-top: 10px;
            }
          }
          & > button {
            margin: 0 auto;
            border-radius: 0;
            border: 0;
            background-color: #eee;
            color: #b3b3b3;
            height: 26px;
            width: 110px;
          }
          &:hover > button {
            background-color: #0b97e0;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
